import React,{Component} from "react";
import {compose} from "redux";
import {withTranslation} from "react-i18next";
import {connect} from "react-redux";
import moment from 'moment';

import ColAtm from "../../../atomic/Col/Col";
import {PageTitle} from "../../../atomic/PageHeader/PageTitle";
import PageHeaderAtm from "../../../atomic/PageHeader/PageHeader";
import {Animated} from "react-animated-css";
import Container from "@material-ui/core/Container";
import {
    getPropertyInventory,
    getQuickPricing,
    updateOrCreateInventory
} from "../../../../redux/actions/Network/Inventory/inventoryAction";
import { propertyBulkUpdateClear,getPropertyBulkUpdate } from "../../../../redux/actions/Network/Inventory/BulkUpdateAction";
import { InventoryLink, InventoryLinkClear } from "../../../../redux/actions/Network/Inventory/inventoryLinkAction";
import { getChannelSetup } from "../../../../redux/actions/Network/Channel/channelSetup.actions";
import {NETWORK, NETWORK_INVENTORY_LIST, NETWORK_COMPETITOR_DASH} from "../../../../constants/appUrls.constants";
import {addDateAndReturnRange, isDefined} from "../../../../utils";
import PriceDateRange from "./components/PriceDateRange";
import ErrorModal from "../../../organisms/Modal/ErrorModal/ErrorModal";
import {Grid} from "@material-ui/core";
import ButtonAtm from "../../../atomic/Button/Button";
import SuccessInventoryModal from "../../../organisms/Modal/SuccessModal/SuccessInventoryModal";
import SuccessModal from "../../../organisms/Modal/SuccessModal/SuccessModal";
import Competitor from "./components/CompetitorAnalysis";
import {
    getCpaClearState,
    getCpaDailyPrice,
    getPropertyCpa, setSyncCpaCompetitorClearState
} from "../../../../redux/actions/Network/Inventory/CompetitorActions";
import {getChannelCancellationList} from "../../../../redux/actions/Network/Channel/channelCancellation.actions";
import { getProperty } from "../../../../utils";
import axios from "axios";
import { USER_MENU } from "../../../../constants/api.constants";
import { getAppLang } from "../../../../utils";
import UpdateOrCreateCompetitorAnalysisModal from "./components/UpdateOrCreateCompetitorAnalysisModal";
import CompetitorFilter from "./CompetitorFilter";
import Button from '@material-ui/core/Button';
import ButtonGroup from '@material-ui/core/ButtonGroup';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import Menu from "@material-ui/core/Menu";
import MenuItem from '@material-ui/core/MenuItem';
import { propertyProducts } from "../../../../redux/actions/propertyProductsActions";
import NotAllowedPage from "../../Global/NotAllowedPage/NotAllowedPage";
import NotAllowedCpaPage from "../../Global/NotAllowedPage/NotAllowedDemoPage";
import Card from '@material-ui/core/Card';
import InventorySkeleton from "../../../molecules/InventorySkeleton/InventorySkeleton";
import LabelAtm from "../../../atomic/Label/Label";
import CircularProgress from '@material-ui/core/CircularProgress';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import { AI_COMPETITOR_ANALYSIS, BEST_AVAILABLE_PRICE } from "../../../../constants/api.constants";

let t=null;

// Summary Card Component
const SummaryCard = ({ title, mainValue, subText, subTextColor, icon, secondaryInfo, providerText, providerLogo }) => (
    <Card style={{
        padding: '16px 20px',
        borderRadius: 8,
        boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        minHeight: 120,
        textAlign: "right",
        position: "relative"
    }}>
        {providerLogo && (
            <div className="cpa-summary-card-provider" 
                style={{
                    position: "absolute",
                    left: 20,
                    fontWeight: 600,
                    textAlign: "left",
                    textTransform: "capitalize"
            }}>
                <img alt={providerText || ''} style={{ width: "45%", height: "auto" }} src={providerLogo || ''} />
            </div>
        )}
        <div style={{ fontSize: 13, color: '#666', fontWeight: 500, marginBottom: 8, textTransform: "capitalize" }}>
            {icon && <span style={{ marginRight: 6 }}>{icon}</span>}
            {title}
        </div>
        <div style={{ fontSize: 28, fontWeight: 700, color: '#222', marginBottom: 4 }}>
            {mainValue}
        </div>
        {subText && (
            <div style={{ fontSize: 13, fontWeight: 600, textTransform: "capitalize", color: subTextColor || '#666' }}>
                {subText}
            </div>
        )}
        {secondaryInfo && (
            <div style={{ fontSize: 12, textTransform: "capitalize", color: '#888', marginTop: 4 }}>
                {secondaryInfo}
            </div>
        )}
    </Card>
);

class Index extends Component {

    constructor(props) {
        super(props);
        this.state = {
            allDays : addDateAndReturnRange(moment(new Date()).format("YYYY-MM-DD"), 14,'day'),
            startDate: moment(new Date()).format("YYYY-MM-DD"),
            endDate: moment(new Date()).add(14, 'days').format("YYYY-MM-DD"),
            channelId : this.props.match.params.id,
            isPriceUpdate : false,
            showStopSell : false,
            showMinStay : false,
            showCompetitor : false,
            showQuickPricing : false,
            propertyName : '',
            competitorTrigger: 0,
            showFilters: false,
            downloadExcel: false,
            menuAnchorEl: null,
            selectedProvider: "",
            allProviders: [],
            isLoading: false,
            competitorHotelAdded: false,
            chartKey: Date.now(),
            currency: null,
            aiAnalysisLoading: false,
            aiAnalysisResponse: null,
            showAiComment: false,
            cpaFullFilled: false,
            propertyNameCompetitor: '',
            aiAnalysisBtnAnimated: false,
            aiAnalysisBtnAnimationKey: 0,
            currentPropertyPrices: {},
            currentPropertyInfo: null,
            getBestAvailableRate : false
        };
        t = props.t;
    }

    calculateSummaryData = () => {
        const { getCpa, prices } = this.props;
        const { currentPropertyPrices, currentPropertyInfo, currency, selectedProvider } = this.state;
        const lsAllDays = JSON.parse(localStorage.getItem("allDays")) || [];

        let selectedProviderLogo = null;
        if (selectedProvider) {
            Object.values(this.props.prices).some(priceObj => {
                if (Array.isArray(priceObj.all)) {
                    const found = priceObj.all.find(
                        item => item.provider && item.provider.trim().toLowerCase() === selectedProvider.toLowerCase()
                    );
                    if (found && found.logo) {
                        selectedProviderLogo = found.logo;
                        return true;
                    }
                }
                return false;
            });
        }
        
        // 1. Kendi otelimizin ortalama fiyatı
        let myTotalPrice = 0;
        let myPriceCount = 0;
        
        if (currentPropertyPrices && Object.keys(currentPropertyPrices).length > 0) {
            Object.values(currentPropertyPrices).forEach(priceObj => {
                if (priceObj && typeof priceObj.amount === 'number' && priceObj.amount > 0) {
                    myTotalPrice += priceObj.amount;
                    myPriceCount++;
                }
            });
        }
        
        const myAveragePrice = myPriceCount > 0 ? Math.round(myTotalPrice / myPriceCount) : null;

        // 2. Rakiplerin ortalama fiyatı (provider filtresine göre)
        let competitorTotalPrice = 0;
        let competitorPriceCount = 0;
        let cheapestCompetitor = { amount: Infinity, date: null, hotelName: null };
        let expensiveCompetitor = { amount: -Infinity, date: null, hotelName: null };

        (getCpa || []).forEach(hotel => {
            lsAllDays.forEach(date => {
                const key = `${hotel.key}_${date}`;
                const priceObj = prices[key];
                
                if (!priceObj) return;

                let amount = null;
                let currencyValue = priceObj?.currency || currency;

                // Provider filtreleme
                if (selectedProvider) {
                    // Seçili provider'a göre fiyat bul
                    if (priceObj.provider && priceObj.provider.trim().toLowerCase() === selectedProvider.toLowerCase()) {
                        amount = priceObj.amount;
                    } else if (Array.isArray(priceObj.all)) {
                        const found = priceObj.all.find(
                            item => item.provider && item.provider.trim().toLowerCase() === selectedProvider.toLowerCase()
                        );
                        if (found && typeof found.amount === 'number') {
                            amount = found.amount;
                            currencyValue = found.currencyCode || currencyValue;
                        }
                    }
                } else {
                    // Filtre yoksa en düşük fiyatı al (varsayılan davranış)
                    amount = priceObj.amount;
                }

                // Geçerli fiyat varsa hesapla
                if (typeof amount === 'number' && amount > 0) {
                    competitorTotalPrice += amount;
                    competitorPriceCount++;

                    // En ucuz rakip kontrolü
                    if (amount < cheapestCompetitor.amount) {
                        cheapestCompetitor = {
                            amount: amount,
                            date: date,
                            hotelName: hotel?.name,
                            currency: currencyValue
                        };
                    }

                    // En pahalı rakip kontrolü
                    if (amount > expensiveCompetitor.amount) {
                        expensiveCompetitor = {
                            amount: amount,
                            date: date,
                            hotelName: hotel?.name,
                            currency: currencyValue
                        };
                    }
                }
            });
        });
        
        const competitorAveragePrice = competitorPriceCount > 0 ? Math.round(competitorTotalPrice / competitorPriceCount) : null;

        // Yüzde fark hesaplama (kendi fiyatımız vs rakip ortalaması)
        let myPriceDiffPercent = null;
        let myPriceDiffText = '';
        let myPriceDiffColor = '#666';
        
        if (myAveragePrice && competitorAveragePrice && competitorAveragePrice > 0) {
            myPriceDiffPercent = ((myAveragePrice - competitorAveragePrice) / competitorAveragePrice) * 100;
            if (Math.abs(myPriceDiffPercent) < 0.5) {
                myPriceDiffText = t('enw-cpa-same_price');
                // myPriceDiffColor = '#757575';
            } else if (myPriceDiffPercent > 0) {
                myPriceDiffText = `%${Math.abs(myPriceDiffPercent).toFixed(0)} ${t('enw-cpa-more_expensive')} ↑`;
                // myPriceDiffColor = '#d32f2f';
            } else {
                myPriceDiffText = `%${Math.abs(myPriceDiffPercent).toFixed(0)} ${t('enw-cpa-cheaper')} ↓`;
                // myPriceDiffColor = '#388e3c';
            }
        }

        // Rakip ortalaması için ters yüzde fark
        let competitorDiffText = '';
        let competitorDiffColor = '#666';
        if (myAveragePrice && competitorAveragePrice && myAveragePrice > 0) {
            const competitorDiffPercent = ((competitorAveragePrice - myAveragePrice) / myAveragePrice) * 100;
            if (Math.abs(competitorDiffPercent) < 0.5) {
                competitorDiffText = t('enw-cpa-same_price');
                // competitorDiffColor = '#757575';
            } else if (competitorDiffPercent > 0) {
                competitorDiffText = `%${Math.abs(competitorDiffPercent).toFixed(0)} ${t('enw-cpa-higher')} ↑`;
                // competitorDiffColor = '#d32f2f';
            } else {
                competitorDiffText = `%${Math.abs(competitorDiffPercent).toFixed(0)} ${t('enw-cpa-lower')} ↓`;
                // competitorDiffColor = '#388e3c';
            }
        }

        return {
            myAveragePrice,
            myPriceDiffText,
            myPriceDiffColor,
            competitorAveragePrice,
            competitorDiffText,
            competitorDiffColor,
            cheapestCompetitor: cheapestCompetitor?.amount !== Infinity ? cheapestCompetitor : null,
            expensiveCompetitor: expensiveCompetitor?.amount !== -Infinity ? expensiveCompetitor : null,
            currency: currency || 'EUR',
            selectedProvider: selectedProvider || null,
            selectedProviderLogo
        };
    };

    componentDidMount() {
        this.props.getPropertyCpa();
        this.props.propertyProducts();
        this.props.getChannelSetup({ channel_id : 1 });

        const params = {
            params: {
                property_id: getProperty(),
                type : "date",
            }
        }
        axios.post(USER_MENU, params, {
            headers: {
                "Accept": "application/json",
                authToken: localStorage.getItem('auth'),
                "Content-Type": "application/json",
                "language": getAppLang(),
            }
        }).then((result) => {
            this.setState({propertyName: result.data.data.property_list[0].name + " - "});
            this.setState({propertyNameCompetitor: result.data.data.property_list[0].name});
        }).then((result) => {
            setTimeout(() => {
                this.fetchBestAvailableRate()
                    .then((bestRate) => {
                        if (bestRate) {
                            const data = bestRate;
                            // Otel bilgisi
                            this.setState({
                                currentPropertyInfo: {
                                    name: this.state.propertyNameCompetitor,
                                    key: "property-" + getProperty(), 
                                    currency: data?.currency,
                                }
                            });
                            const hasData = data && typeof data === "object" && !Array.isArray(data) && data.date && Object.keys(data.date).length > 0;
                            const pricesObj = {};
                            if (hasData) {
                                Object.entries(data.date).forEach(([date, obj]) => {
                                    pricesObj[`${"property-"}${getProperty()}_${date}`] = {
                                        amount: obj.rate,
                                        currency: data?.currency,
                                        provider: "",
                                    };
                                });
                            }
                            this.setState({currentPropertyPrices: pricesObj})
                            this.setState({getBestAvailableRate: true})
                            localStorage.setItem("getBestAvailableRate", "true");
                        } else {
                            console.log("Best available rate not found");
                            localStorage.setItem("getBestAvailableRate", "false");
                            this.setState({getBestAvailableRate: false})
                        }
                    })
            }, 100);
            
        }).catch(function (error) {
            console.log(error);
        });
    }

    getPropertyInvertory = () => {

        const {channelId, startDate, endDate} = this.state

        if ( channelId !== undefined && channelId !== '' && !isNaN(channelId) )
        {
            this.props.getPropertyInventory( startDate, endDate, channelId );

        }else{
            this.props.history.replace(NETWORK);
        }
    }

    getPropertyInvertoryDate = (startDate, endDate) => {

        const {channelId} = this.state

        if ( channelId !== undefined && channelId !== '' )
        {
            this.props.getPropertyInventory( startDate, endDate, channelId );
        }
    }

    nextDate = (startDate, endDate) => {
        this.getPropertyInvertoryDate(startDate,endDate);
    }

    previousDate = (startDate, endDate) => {
        this.getPropertyInvertoryDate(startDate,endDate);
    }


    showMessage = () => {
        const {channelId} = this.state;
        if( this.props.inventoryUpdate === 200 ){
            return <SuccessInventoryModal status={true}
                                          message={t('enw-notification_success')}
                                          channelId={channelId}
            />
        }

        if( this.props.error !== {}  &&
            this.props.error?.response
        ){
            let message = this.props.error.response.data.message
            return  <ErrorModal status={true} message={message}/>
        }
    }

    showInventoryLinkMessage = () => {

        const linkData = isDefined(this.props.inventoryLinkData) && isDefined(this.props.inventoryLinkData.inventoryLink) && this.props.inventoryLinkData.inventoryLink
        const error = isDefined(this.props.inventoryLinkData) && isDefined(this.props.inventoryLinkData.error) && this.props.inventoryLinkData.error

        if( linkData.status === 200 ){
            return <SuccessModal status={true}
                                 message={t('enw-notification_success')}
            />
        }

        if( error !== {}  &&
            error?.response
        ){
            let message = error.response.data.message
            return  <ErrorModal status={true} message={message}/>
        }
    }

    showStopSell = () => {
        const { showMinStay, showCompetitor, showQuickPricing } = this.state;

        this.setState({showStopSell: !this.state.showStopSell})

        if(showMinStay || showCompetitor || showQuickPricing) {
            this.setState({showQuickPricing: false, showMinStay: false, showCompetitor: false, showStopSell: true})
        }
    }
    showMinStay = () => {
       this.setState({showMinStay: !this.state.showMinStay})
        const { showStopSell, showCompetitor, showQuickPricing } = this.state;

        if(showStopSell || showCompetitor || showQuickPricing) {
            this.setState({showMinStay: true, showQuickPricing: false, showCompetitor: false, showStopSell: false})
        }
    }

    showCompetitor = () => {
        const { showStopSell, showMinStay, showCompetitor, showQuickPricing, downloadExcel } = this.state;

        this.setState({ chartKey: Date.now() });
        this.setState({showCompetitor: !this.state.showCompetitor});

        this.setState({ isLoading: true, showCompetitor: !this.state.showCompetitor });
        this.setState(prevState => ({
            competitorTrigger: prevState.competitorTrigger + 1
        }));

         if (this.state.showCompetitor === false) {
            this.fetchBestAvailableRate()
                .then((bestRate) => {
                    if (bestRate) {
                        const data = bestRate;
                        this.setState({
                            currentPropertyInfo: {
                                name: this.state.propertyNameCompetitor,
                                key: "property-" + getProperty(), 
                                currency: data?.currency,
                            }
                        });
                        const hasData = data && typeof data === "object" && !Array.isArray(data) && data.date && Object.keys(data.date).length > 0;
                        const pricesObj = {};
                        if (hasData) {
                            Object.entries(data.date).forEach(([date, obj]) => {
                                pricesObj[`${"property-"}${getProperty()}_${date}`] = {
                                    amount: obj.rate,
                                    currency: data?.currency,
                                    provider: "",
                                };
                            });
                        }
                        this.setState({
                            currentPropertyPrices: pricesObj,
                            getBestAvailableRate: true
                        });
                        localStorage.setItem("getBestAvailableRate", "true");
                    }
                })
                .catch((error) => {
                    console.log("Best available rate error:", error);
                });
        }

        if (this.state.showCompetitor === false) {
            this.props.setSyncCpaCompetitorClearState();
            this.props.getCpaClearState();
            window.stop();
        }
        
        this.setState(prevState => ({
            competitorTrigger: prevState.competitorTrigger + 1
        }));

        if(showStopSell || showMinStay || showQuickPricing) {
            this.setState({showQuickPricing: false, showMinStay: false, showStopSell: false, showCompetitor: true})
        }

        if (showCompetitor === false) {
            this.props.setSyncCpaCompetitorClearState();
            this.props.getCpaClearState();

            window.stop();
        }
    }

    showFilters = () => {
        if (this.state.competitorTrigger !== 0) {
            this.setState({showFilters: true})
        }
    }

     downloadExcelFile = () => {
        this.setState({downloadExcel: true})
        setTimeout(() => {
            this.setState({downloadExcel: false})
        }, 100);
    }

    handleMenuOpen = (event) => {
        this.setState({ menuAnchorEl: event.currentTarget });
    };

    handleMenuClose = () => {
        this.setState({ menuAnchorEl: null });
    };

    handleProviderChange = (e) => {
        this.setState({ selectedProvider: e.target.value });
    };
    handleProvidersChange = (providers) => {
        this.setState({ allProviders: providers });
    };
    handleCompetitorHotelAdded = () => {
        this.setState({ competitorHotelAdded: true });
    }

    getProviderLogos = () => {
        const { prices } = this.props;
        const providerLogos = {};
        Object.values(prices).forEach(priceObj => {
            if (Array.isArray(priceObj?.all)) {
                priceObj.all.forEach(item => {
                    if (item.provider && item.logo) {
                        providerLogos[item.provider.trim().toLowerCase()] = item.logo;
                    }
                });
            }
        });
        return providerLogos;
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.state.isLoading && this.props.prices && Object.keys(this.props.prices).length > 0 && this.props.prices !== prevProps.prices) {
            this.setState({ isLoading: false });
        } else if(this.state.isLoading && this.props.prices && this.props.prices === prevProps.prices) {
            setTimeout(() => {
                this.setState({ isLoading: false });
            }, 1000);
        }

        if (this.props.channelInformationData !== prevProps.channelInformationData) {
            if (this.props.channelInformationData && !Array.isArray(this.props.channelInformationData) && typeof this.props.channelInformationData === 'object' &&
                this.props.channelInformationData.currency &&
                this.props.channelInformationData.currency !== this.state.currency
            ) {
                this.setState({ currency: this.props.channelInformationData.currency });
            } else if (Array.isArray(this.props.channelInformationData) && this.state.currency !== 'USD') {
                this.setState({ currency: 'USD' });
            }
        }

        if (prevState.currentPropertyPrices !== this.state.currentPropertyPrices) {
            this.forceUpdate();
        }

        // const propertyProductCompetitor = !this.props.propertyProductsReducer.fetching &&
        //     isDefined(this.props.propertyProductsReducer) &&
        //     isDefined(this.props.propertyProductsReducer.get_products) &&
        //     Object.values(this.props.propertyProductsReducer.get_products.data).filter(item => "competitor-analysis" === item.route)

        // if (propertyProductCompetitor.length > 0) {
        //     if (!propertyProductCompetitor[0].property_has_product) {
        //         this.props.history.replace(NETWORK);
        //     }
        // }

        const loadingValues = Object.values(this.props?.cpaReducer?.loading || {});
        const allDone = loadingValues.length > 0 && loadingValues.every(v => v === false);

       if (!prevState.cpaFullFilled && allDone) {
            this.setState({
                cpaFullFilled: true,
                aiAnalysisBtnAnimated: true,
                aiAnalysisBtnAnimationKey: Date.now()
            }, () => {
                setTimeout(() => {
                    this.setState({ aiAnalysisBtnAnimated: false });
                }, 1200);
            });
        } else if (prevState.cpaFullFilled && !allDone) {
            this.setState({ cpaFullFilled: false });
        }

    }

    // Property Payload
    getPropertyPayload = (bestAvailableRate, propertyName) => {
        const prices = {};
        if (bestAvailableRate?.date) {
            Object.entries(bestAvailableRate.date).forEach(([date, obj]) => {
                prices[date] = obj.rate;
            });
        }
        return {
            name: this.state?.propertyNameCompetitor ?? "",
            currency: bestAvailableRate?.currency ?? "EUR",
            prices
        };
    };

    // Competitor Payload
    getCompetitorPayload = (getCpa, prices, lsAllDays) => {
        return (getCpa || []).map(hotel => {
            const hotelPrices = {};
            lsAllDays.forEach(date => {
                const key = `${hotel.key}_${date}`;
                const priceObj = prices[key];
                if (priceObj?.amount !== null && priceObj?.amount !== undefined) {
                    hotelPrices[date] = priceObj.amount;
                }
            });
            return {
                name: hotel?.name,
                currency: hotel?.currency ?? "EUR",
                prices: hotelPrices
            };
        });
    };

    // Best Available Rate
    fetchBestAvailableRate = () => {
        const lsAllDays = JSON.parse(localStorage.getItem("allDays"));
        const params = {
            params: {
                property_id: getProperty(),
                start_date: lsAllDays[0],
                finish_date: lsAllDays[lsAllDays.length - 1],
                type : "range"
            }
        };
        return axios.post(BEST_AVAILABLE_PRICE, params, {
            headers: {
                "Accept": "application/json",
                authToken: localStorage.getItem('auth'),
                "Content-Type": "application/json",
                "language": getAppLang(),
            }
        }).then((result) => {
            this.setState({getBestAvailableRate: true})
            return result.data.data; // Promise zinciri
        }).catch((error) => {
            console.log(error);
            localStorage.setItem("getBestAvailableRate", "false");
            this.setState({getBestAvailableRate: false});
            throw error;
        });
    };

    // AI Competitor Analysis
    postAiCompetitorAnalysis = ({ property_id, language, property, competitor }) => {
        const payload = {
            params: {
                property_id,
                language,
                property,
                competitor
            }
        };

        return axios.post(AI_COMPETITOR_ANALYSIS, payload, {
            headers: {
                "Accept": "application/json",
                "Content-Type": "application/json",
                authToken: localStorage.getItem('auth'),
                "language": getAppLang(),
            }
        });
    };

    handleAiAnalysisClick = () => {
        if (this.state.aiAnalysisLoading) return;
        this.setState({ aiAnalysisLoading: true });
        
        const lsSelectedDays = JSON.parse(localStorage.getItem("allDays"));

        this.fetchBestAvailableRate()
            .then((bestRate) => {
                if (bestRate) {
                    const propertyPayload = this.getPropertyPayload(bestRate, this.state.propertyName);
                    const competitorPayload = this.getCompetitorPayload(
                        this.props.getCpa,
                        this.props.prices,
                        lsSelectedDays
                    );

                    const hasValidPrices = competitorPayload.some(hotel => Object.keys(hotel.prices).length > 0);

                    if (hasValidPrices) {
                        return this.postAiCompetitorAnalysis({
                            property_id: getProperty(),
                            language: getAppLang(),
                            property: propertyPayload,
                            competitor: competitorPayload
                        });
                    }
                } else {
                    console.log("Best available rate not found");
                }
            })
            .then(response => {
                this.setState({
                    aiAnalysisResponse: response?.data,
                    showAiComment: !!response?.data?.data?.comment
                });
            })
            .catch(error => {
                console.error("AI analysis error:", error);
            })
            .finally(() => {
                this.setState({ aiAnalysisLoading: false });
            });
    };

    render() {
        const {t, inventory, channelInformationData, channelInformationFetching, getCpa, cpaReducer, propertyProductsReducer} = this.props;
        const {allDays, startDate, endDate, showCompetitor, showFilters, downloadExcel, competitorTrigger, allProviders} = this.state;
        const screenWidth = window.innerWidth;

        const propertyProductCompetitor = !this.props.propertyProductsReducer.fetching &&
            isDefined(this.props.propertyProductsReducer) &&
            isDefined(this.props.propertyProductsReducer.get_products) &&
            Object.values(this.props.propertyProductsReducer.get_products.data).filter(item => "competitor-analysis" === item.route)
            // if (propertyProductCompetitor[0]) {
            //     propertyProductCompetitor[0].status = 3;
            //     propertyProductCompetitor[0].property_has_product = false;
            // } // Demo sonu test
        const summaryData = this.calculateSummaryData();

        const cmpProduct = isDefined(this.props.propertyProductsReducer?.get_products?.data)
            ? Object.values(this.props.propertyProductsReducer.get_products.data).find(item => item.route === "competitor-analysis")
            : null;

        const hasParams = cmpProduct?.parameters?.length > 0;
        const showExcelReport = !hasParams || cmpProduct.parameters.some(p => p?.product_parameter_id === 703 && p?.is_selected === 1);
        const showAiAnalysis  = !hasParams || cmpProduct.parameters.some(p => p?.product_parameter_id === 704 && p?.is_selected === 1);

        const param701 = hasParams ? cmpProduct.parameters.find(p => p?.product_parameter_id === 701 && p?.is_selected === 1) : null;
        const maxForwardDays = param701 ? parseInt(param701.value, 10) : null;

        return(
            <>
                <PageTitle title={ t('enw-input-competitor') } />
                <PageHeaderAtm 
                    backButton={NETWORK_COMPETITOR_DASH}
                    exitText={ t('btn-dashboard') }
                    text={ t('enw-input-competitor') }
                />
                {
                    isDefined(propertyProductCompetitor[0]) && !propertyProductCompetitor[0].property_has_product && propertyProductCompetitor[0].status === 1 ?
                        <Animated animationIn="bounceInRight" animationInDuration={1000} isVisible={true}>
                            <Grid item xs={12} lg={6} className="no-buy-product no-buy-product-web">
                                <Card className="p-24">
                                    <NotAllowedCpaPage productId={propertyProductCompetitor[0]?.id} isTrialEnd={false} />
                                </Card>
                            </Grid>
                        </Animated>
                    : 
                    isDefined(propertyProductCompetitor[0]) && !propertyProductCompetitor[0].property_has_product && propertyProductCompetitor[0].status === 3 ?
                        <Animated animationIn="bounceInRight" animationInDuration={1000} isVisible={true}>
                            <Grid item xs={12} lg={6} className="no-buy-product no-buy-product-web">
                                <Card className="p-24">
                                    <NotAllowedCpaPage
                                        trialEndTitle = {t('enw-trial_end-product_title')}
                                        trialEndDesc = {t('enw-trial_end-product_desc')}
                                        trialEndBtnText = {t('enw-not-product_btn')}
                                        isTrialEnd={true}
                                    />
                                </Card>
                            </Grid>
                        </Animated>
                    :
                    this.props.propertyProductsReducer.fetching || cpaReducer?.fetching ?
                        <>
                            <style>{`
                                @media (min-width: 768px) {
                                    .skeleton-inventory-box {
                                        width: 87.5% !important;
                                        margin: 0 auto !important;
                                        margin-top:32px !important;
                                        height:auto!important
                                    }
                                }
                            `}</style>
                            <InventorySkeleton/>
                        </>
                    :
                    !cpaReducer?.fetching && cpaReducer?.getCpa?.length > 0 ?
                    <>
                    {this.state.aiAnalysisResponse?.data?.comment && this.state.showAiComment && (
                        <Animated animationIn="bounceInUp" animationInDuration={1000} isVisible={true}
                            style={{position: "fixed", bottom: "1px", right: "1px", width: "100%", zIndex: "999", justifyContent: "center", display: "flex" }} 
                        >
                            <div className="competitor-ai-comment-box">
                                {/* <i className="fas fa-robot" style={{ color: "#d71f26", fontSize: 32, marginRight: 8 }} /> */}
                                <svg xmlns="http://www.w3.org/2000/svg" style={{color: "#d71f26"}} className="competitor-ai-svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" ><path d="M9.937 15.5A2 2 0 0 0 8.5 14.063l-6.135-1.582a.5.5 0 0 1 0-.962L8.5 9.936A2 2 0 0 0 9.937 8.5l1.582-6.135a.5.5 0 0 1 .963 0L14.063 8.5A2 2 0 0 0 15.5 9.937l6.135 1.581a.5.5 0 0 1 0 .964L15.5 14.063a2 2 0 0 0-1.437 1.437l-1.582 6.135a.5.5 0 0 1-.963 0z"></path><path d="M20 3v4"></path><path d="M22 5h-4"></path><path d="M4 17v2"></path><path d="M5 18H3"></path></svg>
                                <div style={{ flex: 1, fontSize: 16, color: "#222", maxHeight: "500px", overflow: "scroll" }}>
                                    {this.state.aiAnalysisResponse.data.comment} <span style={{fontWeight: 600}}>{this.state.aiAnalysisResponse?.data?.recommendation}</span>
                                </div>
                                <IconButton
                                    size="small"
                                    onClick={() => this.setState({ showAiComment: false })}
                                    style={{ marginLeft: 8 }}
                                >
                                    <CloseIcon />
                                </IconButton>
                            </div>
                        </Animated>
                    )}
                    <Animated animationIn="bounceInRight" animationInDuration={1000} isVisible={true}>
                        <Container maxWidth="xl">
                            <div className="container-width m-inventory-container">
                                <Grid container className="mb-16 cpa-button-container" spacing={screenWidth > 768 ? 3 : 0}>
                                    <Grid item xs={12} md={1} className="cpa-top-buttons-left">
                                            <ButtonAtm 
                                                className="inventory-action-btn bg-green inventory-filter-box"
                                                buttontext={this.state.isLoading ? t('enw-payment-manual_payment-loading-message') : t('btn-start-competitor_analysis') } //{ t('enw-input-competitor') }
                                                fullwidth={screenWidth > 768 ? false : true}
                                                onClick={this.showCompetitor}
                                                disabled={this.state.isLoading || getCpa?.length < 1}
                                                startIcon={this.state.isLoading ? 
                                                <i style={{fontSize: "12px", marginTop: "2px"}} className="fas fa-spinner-third fa-spin"></i> 
                                                : <i style={{fontSize: "12px", marginTop: "2px"}} className="fas fa-play" />}
                                            />
                                    </Grid>

                                    <Grid item xs={12} md={11} className="cpa-top-buttons">
                                        <UpdateOrCreateCompetitorAnalysisModal
                                            allDays={localStorage.getItem("allDays")}
                                            getCpa={getCpa}
                                            type="edit"
                                            onHotelAdded={this.handleCompetitorHotelAdded}
                                            currency={this.state.currency}
                                            propertyProducts={propertyProductsReducer}
                                        />
                                        {showExcelReport &&
                                            <ButtonAtm className="inventory-action-btn bg-red inventory-filter-box"
                                                buttontext={t('datatable-toolbar-download_excel')}
                                                fullwidth={screenWidth > 768 ? false : true}
                                                onClick={this.downloadExcelFile}
                                                disabled={!this.state.competitorHotelAdded && competitorTrigger === 0}
                                                startIcon={<i style={{fontSize: "12px", marginTop: "2px"}} className="fas fa-file-excel" />}
                                            />
                                        }

                                        <ButtonGroup
                                            variant="contained"
                                            className="cpa-filter-btn"
                                            style={{
                                                borderRadius: 8,
                                                boxShadow: "none"
                                            }}
                                        >
                                            <Button
                                                style={{
                                                    color: "#fff",
                                                    minWidth: 120,
                                                    fontWeight: 700,
                                                    textTransform: "none",
                                                    borderRadius: "8px"
                                                }}
                                                className="bg-dark-orange"
                                                onClick={this.handleMenuOpen}
                                                disabled={!this.state.competitorHotelAdded && competitorTrigger === 0}
                                                startIcon={<i style={{fontSize: "12px", marginTop: "2px"}} className="fas fa-filter" />}
                                                fullwidth={screenWidth > 768 ? false : true}
                                            >
                                                {this.state.selectedProvider
                                                    ? this.state.selectedProvider.charAt(0).toUpperCase() + this.state.selectedProvider.slice(1)
                                                    : t('enw-input-filter_provider-title')}
                                                <ArrowDropDownIcon />
                                            </Button>
                                            {showAiAnalysis &&
                                                <Animated
                                                    key={this.state.aiAnalysisBtnAnimationKey}
                                                    animationIn={this.state.aiAnalysisBtnAnimated ? "bounce" : ""}
                                                    animationInDuration={1000}
                                                    isVisible={true}
                                                    style={{display : (this.state.getBestAvailableRate || localStorage.getItem("getBestAvailableRate") === "true") ? "block" : "none"}}
                                                >
                                                { this.state.getBestAvailableRate &&
                                                    <ButtonAtm className="inventory-action-btn inventory-filter-box" style={{backgroundColor: "#f50057"}}
                                                        buttontext={this.state.aiAnalysisLoading ? t('enw-payment-manual_payment-loading-message') : t('enw-ai_analysis-title')}
                                                        fullwidth={screenWidth > 768 ? false : true}
                                                        onClick={this.handleAiAnalysisClick}
                                                        disabled={this.state.aiAnalysisLoading || this.state.showAiComment || !this.state.cpaFullFilled}
                                                        startIcon={
                                                            this.state.aiAnalysisLoading ?
                                                                <i style={{fontSize: "12px", marginTop: "2px"}} className="fas fa-spinner-third fa-spin"></i> 
                                                                : 
                                                                <svg xmlns="http://www.w3.org/2000/svg" className="competitor-ai-svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M9.937 15.5A2 2 0 0 0 8.5 14.063l-6.135-1.582a.5.5 0 0 1 0-.962L8.5 9.936A2 2 0 0 0 9.937 8.5l1.582-6.135a.5.5 0 0 1 .963 0L14.063 8.5A2 2 0 0 0 15.5 9.937l6.135 1.581a.5.5 0 0 1 0 .964L15.5 14.063a2 2 0 0 0-1.437 1.437l-1.582 6.135a.5.5 0 0 1-.963 0z"></path><path d="M20 3v4"></path><path d="M22 5h-4"></path><path d="M4 17v2"></path><path d="M5 18H3"></path></svg>}
                                                    />
                                                }
                                                </Animated>
                                            }

                                            <Menu
                                                id="filter-menu"
                                                anchorEl={this.state.menuAnchorEl}
                                                keepMounted
                                                open={Boolean(this.state.menuAnchorEl)}
                                                onClose={this.handleMenuClose}
                                            >
                                                <CompetitorFilter
                                                    providers={allProviders}
                                                    selectedProvider={this.state.selectedProvider}
                                                    onChange={this.handleProviderChange}
                                                    onClose={this.handleMenuClose}
                                                    providerLogos={this.getProviderLogos()}
                                                />
                                            </Menu>
                                        </ButtonGroup>

                                    </Grid>
                                </Grid>

                                {/* Summary Cards */}
                                {competitorTrigger > 0 && (
                                    <Animated style={{position: "relative"}} animationIn="fadeIn" animationInDuration={700} isVisible={true}>
                                        {/* {this.state.selectedProvider && (
                                            <div style={{ 
                                                marginBottom: 8, 
                                                fontSize: 13, 
                                                color: '#1976d2',
                                                fontWeight: 500,
                                                display: 'flex',
                                                alignItems: 'center',
                                                gap: 6
                                            }}>
                                                <i className="fas fa-filter" style={{ fontSize: 11 }} />
                                                {t('enw-cpa-filtered_by_provider')}: <strong>{this.state.selectedProvider.charAt(0).toUpperCase() + this.state.selectedProvider.slice(1)}</strong>
                                            </div>
                                        )} */}
                                        <Grid container style={{ margin: "0px 0px 10px 0px", width: "100%" }}>
                                            {/* 1. Kutu: Ortalama Fiyatınız */}
                                            <Grid item xs={12} sm={6} md={3} style={{ padding: screenWidth > 768 ? "8px 8px 8px 0px" : "8px 0px"}}>
                                                <SummaryCard
                                                    title={t('enw-cpa-your_average_price')}
                                                    icon={<i className="fas fa-hotel" style={{ color: '#1976d2' }} />}
                                                    mainValue={summaryData.myAveragePrice ? `${summaryData.myAveragePrice} ${summaryData.currency}` : '-'}
                                                    subText={summaryData.myPriceDiffText}
                                                    subTextColor={summaryData.myPriceDiffColor}
                                                    providerText={summaryData.selectedProvider}
                                                    providerLogo={summaryData.selectedProviderLogo}
                                                />
                                            </Grid>

                                            {/* 2. Kutu: Rakip Ortalaması */}
                                            <Grid item xs={12} sm={6} md={3} style={{padding: screenWidth > 768 ? "8px 8px 8px 8px" : "8px 0px"}}>
                                                <SummaryCard
                                                    title={t('enw-cpa-competitor_average')}
                                                    icon={<i className="fas fa-users" style={{ color: '#f57c00' }} />}
                                                    mainValue={summaryData.competitorAveragePrice ? `${summaryData.competitorAveragePrice} ${summaryData.currency}` : '-'}
                                                    subText={summaryData.competitorDiffText}
                                                    subTextColor={summaryData.competitorDiffColor}
                                                    providerText={summaryData.selectedProvider}
                                                    providerLogo={summaryData.selectedProviderLogo}
                                                />
                                            </Grid>

                                            {/* 3. Kutu: Rakip En Ucuz */}
                                            <Grid item xs={12} sm={6} md={3} style={{padding: screenWidth > 768 ? "8px 8px 8px 8px" : "8px 0px"}}>
                                                <SummaryCard
                                                    title={t('enw-cpa-cheapest_competitor')}
                                                    icon={<i className="fas fa-hotel" style={{ color: '#886cff' }} />}
                                                    mainValue={summaryData.cheapestCompetitor ? `${summaryData.cheapestCompetitor.amount} ${summaryData.cheapestCompetitor.currency || summaryData.currency}` : '-'}
                                                    subText={summaryData.cheapestCompetitor ? moment(summaryData.cheapestCompetitor.date).format('DD MMM YYYY') : ''}
                                                    subTextColor="#666"
                                                    secondaryInfo={summaryData.cheapestCompetitor?.hotelName || ''}
                                                    providerText={summaryData.selectedProvider}
                                                    providerLogo={summaryData.selectedProviderLogo}
                                                />
                                            </Grid>

                                            {/* 4. Kutu: Rakip En Pahalı */}
                                            <Grid item xs={12} sm={6} md={3} style={{padding: screenWidth > 768 ? "8px 0px 8px 8px" : "8px 0px"}}>
                                                <SummaryCard
                                                    title={t('enw-cpa-most_expensive_competitor')}
                                                    icon={<i className="fas fa-hotel" style={{ color: '#d32f81' }} />}
                                                    mainValue={summaryData.expensiveCompetitor ? `${summaryData.expensiveCompetitor.amount} ${summaryData.expensiveCompetitor.currency || summaryData.currency}` : '-'}
                                                    subText={summaryData.expensiveCompetitor ? moment(summaryData.expensiveCompetitor.date).format('DD MMM YYYY') : ''}
                                                    subTextColor="#666"
                                                    secondaryInfo={summaryData.expensiveCompetitor?.hotelName || ''}
                                                    providerText={summaryData.selectedProvider}
                                                    providerLogo={summaryData.selectedProviderLogo}
                                                />
                                            </Grid>
                                        </Grid>
                                    </Animated>
                                )}
                                <ColAtm>
                                    <PriceDateRange allDays={allDays}
                                                    startDate={startDate}
                                                    endDate={endDate}
                                                    previousDate={this.previousDate}
                                                    nextDate={this.nextDate}
                                                    getPropertyInvertoryDate={this.getPropertyInvertoryDate}
                                                    fetching={this.props.fetching}
                                                    getCpa={getCpa}
                                                    showCompetitor={showCompetitor}
                                                    getCpaDailyPrice={this.props.getCpaDailyPrice}
                                                    getCpaClearState={this.props.getCpaClearState}
                                                    trigger={this.state.competitorTrigger}
                                                    currency={this.state.currency}
                                                    onDateRangeChange={() => {
                                                        if (this.state.showCompetitor) {
                                                            this.setState(prevState => ({
                                                                competitorTrigger: prevState.competitorTrigger + 1
                                                            }));
                                                        }
                                                    }}
                                                    maxForwardDays={maxForwardDays}
                                    />
                                </ColAtm>
                                {
                                    <>
                                        <Competitor
                                            key={this.state.chartKey}
                                            trigger={this.state.competitorTrigger}
                                            allDays={this.state.allDays}
                                            showFilters={showFilters}
                                            downloadExcel={downloadExcel}
                                            selectedProvider={this.state.selectedProvider}
                                            onProvidersChange={this.handleProvidersChange}
                                            currency={this.state.currency}
                                            propertyName={this.state.propertyNameCompetitor}
                                            getBestAvailableRate={err => this.setState({ getBestAvailableRate: err })}
                                            currentPropertyInfo={this.state.currentPropertyInfo}
                                            currentPropertyPrices={this.state.currentPropertyPrices}
                                            // onDataLoaded={() => this.setState({ isLoading: false })}
                                        />
                                    </>
                                }

                            </div>
                        </Container>
                        <style>{`
                            .fa-spin {
                                -webkit-animation: fa-spin 2s linear infinite!important;
                                animation: fa-spin 1s linear infinite!important;
                            }
                            .MuiPopover-paper {
                                width:310px
                            }
                            @media (max-width: 768px) {
                                .MuiPopover-paper {
                                    width:87vw;
                                }
                                .container-width {
                                    padding:20px 0 20px !important;
                                }
                            }
                            .inventory-action-btn {
                                max-height: 45px;
                            }
                            .MuiButtonGroup-groupedContainedHorizontal:not(:last-child).Mui-disabled {
                                border:0px !important;
                            }
                        `}</style>
                    </Animated>
                    </>
                    :
                    <>
                        <Grid container spacing={3} className="mt-60 web-dashboard centered-position">
                            <Container maxWidth="xl">
                                <div className="container-width">
                                    <ColAtm xs={12} className="photoButtonsRow one-page-content">
                                        <ColAtm>
                                            <div className="m-auto first-create-room">
                                                <UpdateOrCreateCompetitorAnalysisModal
                                                    allDays={localStorage.getItem("allDays")}
                                                    getCpa={getCpa}
                                                    currency={this.state.currency}
                                                />
                                            </div>
                                        </ColAtm>
                                        <LabelAtm labelClass="one-page-title"
                                            text={t('btn-create_cpa-first-title')} />
                                        <LabelAtm labelClass="one-page-subtitle p-0-100"
                                            text={t('btn-create_cpa-first-desc')} />
                                    </ColAtm>
                                </div>
                            </Container>
                        </Grid>
                        <style>{`
                            .first-create-room .cpa-new-property-btn {
                                padding: 72px 82px !important;
                                margin-bottom:1rem !important;
                            }
                            .filter-action-button span i {
                                margin-right:0px!important;
                            }
                            .web-dashboard {
                                min-height: calc(100vh - 145px);
                                display: flex;
                                flex-direction: column;
                                justify-content: center;
                                margin-top: 0px !important;
                                align-items: center;
                            }
                        `}</style>
                    </>
                }
                {this.showMessage()}
                {this.showInventoryLinkMessage()}
            </>
            
        )
    }
}


const mapStateToProps = (props) => {
    return {
        fetching        : props.inventoryReducer.fetching,
        error           : props.inventoryReducer.error,
        inventory       : props.inventoryReducer.inventory,
        inventoryUpdate : props.inventoryReducer.inventoryUpdate ?. status,
        inventoryUpdateError : props.inventoryReducer.inventoryUpdate ?. error,
        channelInformationFetching : props.channelSetupReducers.fetching,
        channelInformationData : props.channelSetupReducers.channelInformationData,
        channelAvailability : props.channelSetupReducers.channelInformationAvaility,
        channelSetupData : props.channelSetupReducers.channelSetupData.data,
        inventoryLinkData: props.inventoryLinkReducer,
        getCpa: props.cpaReducer.getCpa,
        cpaReducer: props.cpaReducer,
        quickPricingData: props.quickPricingReducer.quickPricing,
        getQuickPricingData: props.quickPricingReducer,
        propertyProductsReducer : props.propertyProductsReducer,
        prices: props.cpaReducer.prices
    }
};

const mapDispatchToProps ={
    getPropertyInventory,
    getChannelSetup,
    updateOrCreateInventory,
    getPropertyBulkUpdate,
    InventoryLink,
    InventoryLinkClear,
    propertyBulkUpdateClear,
    getPropertyCpa,
    getCpaDailyPrice,
    getCpaClearState,
    setSyncCpaCompetitorClearState,
    getChannelCancellationList,
    getQuickPricing,
    propertyProducts
};
export default compose(withTranslation('common')) (connect(mapStateToProps, mapDispatchToProps )(Index));
